import React, { Component } from 'react'

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Alert } from '@/components/ui/alert'

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, errorMessage: '' }
  }

  componentDidCatch(error) {
    this.setState({
      hasError: true,
      errorMessage: error.message
    })
  }

  render() {
    const { hasError, errorMessage } = this.state

    if (hasError) {
      return (
        <Dialog open>
          <DialogContent
            showClose={false}
            onEscapeKeyDown={e => e.preventDefault()}
            onInteractOutside={e => e.preventDefault()}
          >
            <DialogHeader>
              <DialogTitle>Something went wrong</DialogTitle>
            </DialogHeader>
            <Alert variant="error">We've encountered a bug — {errorMessage}</Alert>
          </DialogContent>
        </Dialog>
      )
    }

    return this.props.children
  }
}
